import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HeaderPortal from 'components/layout/HeaderPortal';
import { withAreaGetter } from 'providers/AreasConsumers';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { defaultLeasingInterestDetail, leasingDetailModalVar } from '../../variables';
import LeasingInterestTypeDetailListBrowser from './LeasingInterestTypeDetailListBrowser';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_LEASING_INTERESTS_READ, ADMIN_LEASING_INTERESTS_WRITE } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_LEASING_INTERESTS_WRITE} withForbiddenPage={false}>
          <IconButton
            type='add'
            fontSize='medium'
            color='transparent'
            tooltip={t('Add')}
            onClick={() => leasingDetailModalVar({ open: true, detail: defaultLeasingInterestDetail })}
          />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_LEASING_INTERESTS_READ}>
        <LeasingInterestTypeDetailListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func
};

export default withAreaGetter(Route);
